import { usePathname } from 'next/navigation';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { camelCase } from 'change-case';

import { Dot } from '@/core/components/Icons/Dot';
import { navigationMessages } from '@/core/messages/navigation.messages';

import {
  StyledLink,
  Wrapper,
} from './Breadcrumbs.styles';

type BreadcrumbsProps = {
  currentPage?: string;
}

export const Breadcrumbs = ({ currentPage = '' }: BreadcrumbsProps) => {
  const { formatMessage } = useIntl();

  const path = usePathname();
  const crumbs = path.split('/').filter(crumb => crumb);

  const links = crumbs.map((_, index) => `/${crumbs.slice(0, index + 1).join('/')}`)
    .map((link, index) => {
      const crumbTitle = index === crumbs.length - 1 && currentPage ?
        currentPage :
        formatMessage(
          navigationMessages[camelCase(crumbs[index]) as keyof typeof navigationMessages]
        );

      return (
        <Fragment key={link}>
          <Dot />
          <StyledLink href={link}>
            {crumbTitle}
          </StyledLink>
        </Fragment>
      );
    });

  return (
    <Wrapper>
      <StyledLink href="/">
        {formatMessage(navigationMessages.home)}
      </StyledLink>
      {links}
    </Wrapper>
  );
};
